import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import THEME from '../../theme';
import File from '../File';
import ChevronDown from '../Icons/ChevronDown';
import ChevronUp from '../Icons/ChevronUp';
import Modal from '../Modal';
import HTMLEmail from './HTMLEmail';
const Email = (props) => {
    const lang = useSelector((s) => s.lang);
    const [open, setOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [emailEvent, setEmailEvent] = useState(null);
    const { interaction } = props;
    const email = interaction.details;
    const events = interaction.events
        ? Object.values(interaction.events.reduce((acc, event) => {
            if (!acc[event.type]) {
                acc[event.type] = [];
            }
            acc[event.type] = acc[event.type].concat(event);
            return acc;
        }, {}))
        : [];
    const getTooltipEventDetails = (s) => {
        return `${moment(s.createdAt).format(THEME.DATE_FORMAT_LONG)}${s.data.provider === 'SPARK_POST'
            ? sparkpostTooltipData(s)
            : mailgunTooltipData(s)}`;
    };
    const getEventDetails = (s) => {
        return {
            date: moment(s.createdAt).format(THEME.DATE_FORMAT_LONG),
            data: s.data.provider === 'SPARK_POST'
                ? sparkpostEventData(s)
                : mailgunEventData(s),
        };
    };
    const sparkpostTooltipData = (s) => {
        return s.data.type && s.data.error_code
            ? `: ${s.data.type} ${s.data.error_code}`
            : '';
    };
    const mailgunTooltipData = (s) => {
        return s.data['event-data'] &&
            s.data['event-data'].severity &&
            s.data['event-data']['delivery-status'] &&
            s.data['event-data']['delivery-status'].code
            ? `: ${s.data['event-data'].severity} ${s.data['event-data']['delivery-status'].code}`
            : '';
    };
    const sparkpostEventData = (s) => {
        return (s.data.type &&
            s.data.reason &&
            s.data.error_code &&
            `Type: ${s.data.type} \nReason: ${s.data.reason} \nError Code: ${s.data.error_code} \nRecipient: ${s.data.rcpt_to}`);
    };
    const mailgunEventData = (s) => {
        return (s.data['event-data'] &&
            s.data['event-data'].severity &&
            s.data['event-data']['delivery-status'] &&
            s.data['event-data']['delivery-status'].code &&
            `Severity: ${s.data['event-data'].severity} \nCode: ${s.data['event-data']['delivery-status'].code} \nMessage: ${s.data['event-data']['delivery-status'].message}`);
    };
    return (React.createElement(EmailStyled, { style: props.style },
        email.from && (React.createElement("div", { className: "from" },
            React.createElement("span", null, lang.interactions.from),
            email.from)),
        email.to && (React.createElement("div", { className: "to" },
            React.createElement("span", null, lang.interactions.to),
            email.to)),
        email.cc && (React.createElement("div", { className: "cc" },
            React.createElement("span", null, "CC"),
            email.cc)),
        email.bcc && (React.createElement("div", { className: "bcc" },
            React.createElement("span", null, "BCC"),
            email.bcc)),
        email.replyTo && (React.createElement("div", { className: "replyto" },
            React.createElement("span", null, "Reply To"),
            email.replyTo)),
        email.subject && (React.createElement("div", { className: "subject" },
            React.createElement("span", null, lang.interactions.subject),
            email.subject)),
        interaction.events && interaction.events.length ? (React.createElement("div", { className: "to" },
            React.createElement("span", null, lang.interactions.events),
            React.createElement(EmailTags, null, events.map((events) => {
                const event = events[0];
                return (React.createElement("div", { key: event.id, "data-tooltip-html": events
                        .map(getTooltipEventDetails)
                        .join('<br/>'), "data-tooltip-id": "tooltip-default", className: event.type, onClick: () => {
                        setEmailEvent(events.map(getEventDetails));
                        setOpenModal(!openModal);
                    } },
                    // @ts-ignore
                    lang.interactions[event.type] || event.type,
                    ' ',
                    events.length > 1 ? `(${events.length})` : ''));
            })))) : (''),
        React.createElement("div", { className: "body" },
            React.createElement(Body, { open: props.noToggle || open, onClick: () => {
                    setOpen(!open);
                } },
                React.createElement("div", null, typeof email.html === 'string' ? (React.createElement(HTMLEmail, { html: email.html })) : (React.createElement("pre", null, email.body))),
                !props.noToggle && (React.createElement(ReadMore, { open: open },
                    React.createElement(ReadMoreText, null,
                        open ? lang.interactions.readLess : lang.interactions.readMore,
                        open ? (React.createElement(ChevronUp, { style: {
                                margin: '-0.1em 0em -0.1em 0.2em',
                            } })) : (React.createElement(ChevronDown, { style: {
                                margin: '-0.1em 0em -0.1em 0.2em',
                            } })))))),
            interaction.attachments && (React.createElement(Attachments, null, interaction.attachments.map((attachment) => (React.createElement(File, { key: attachment.fileId, file: {
                    fileName: attachment.fileName,
                    fileId: attachment.fileId,
                    contentType: attachment.contentType,
                } }))))),
            openModal && (React.createElement(Modal, { onToggle: () => {
                    setEmailEvent(null);
                    setOpenModal(!openModal);
                }, header: lang.interactions.events }, emailEvent &&
                Object.entries(emailEvent).map(([key, value]) => (React.createElement("div", { key: key },
                    React.createElement("h3", null, 
                    // @ts-ignore
                    value === null || value === void 0 ? void 0 : value.date),
                    React.createElement("pre", null, 
                    // @ts-ignore
                    value === null || value === void 0 ? void 0 : value.data)))))))));
};
export default Email;
const EmailStyled = styled.div `
  background: #fff;

  .from,
  .to,
  .cc,
  .bcc,
  .replyto,
  .subject,
  .body {
    border-bottom: 1px solid lightgrey;
    padding: 10px 15px;
  }

  .from > span:first-child,
  .to > span:first-child,
  .cc > span:first-child,
  .bcc > span:first-child,
  .replyto > span:first-child,
  .subject > span:first-child {
    width: 55px;
    opacity: 0.6;
    display: inline-block;
    text-align: right;
    margin-right: 10px;
    font-size: 0.75em;
  }

  .from > span:first-child:after,
  .to > span:first-child:after,
  .cc > span:first-child:after,
  .bcc > span:first-child:after,
  .replyto > span:first-child:after,
  .subject > span:first-child:after {
    content: ': ';
  }

  .body pre {
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: pre-wrap;
  }

  .subject {
    font-weight: bold;
  }

  .date {
    float: right;
    color: lightgrey;
  }

  .email {
    padding: 20px;
  }

  border: 1px solid lightgrey;
  border-bottom: none;
`;
const EmailTags = styled.span `
  & > div {
    background: ${THEME.SUCCESS};
    display: inline-block;
    border-radius: 3px;
    color: ${THEME.COLOR_SECONDARY};
    padding: 0.2em 0.6em;
    font-size: 0.7em;
    font-weight: bold;
    margin-right: 5px;

    &.failed {
      background: ${THEME.DANGEROUS};
    }

    &.complained {
      background: ${THEME.WARNING};
    }
  }
`;
const Body = styled.div `
  position: relative;
  & > div {
    max-height: ${(props) => props.open ? '50000px' : '115px'};
    overflow: hidden;
  }
`;
const ReadMoreText = styled.p `
  text-transform: uppercase;
  font-weight: 900;
  text-align: center;
  margin: 2em 0 0 0;
  color: ${THEME.COLOR_ACCENT};
`;
const ReadMore = styled.div `
  ${(props) => props.open
    ? ''
    : `
        background: rgb(255,255,255);
        background: linear-gradient(0deg, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 100%);
        position: absolute;
  `} bottom: 0;
  width: 100%;
  padding-bottom: 10px;
  cursor: pointer;
`;
const Attachments = styled.div `
  padding: 20px 0;
  border-top: 1px solid lightgrey;
  overflow: auto;
`;
//# sourceMappingURL=Email.js.map